import { EnvironmentInterface } from './intrerface/environment.interface'
import { RumInitConfiguration } from '@datadog/browser-rum'
import { LogsInitConfiguration } from '@datadog/browser-logs'

const dataDogConfigRum: RumInitConfiguration = {
  applicationId: '4b89c16d-31a7-4c0e-8b03-bc4f0fdffdc9',
  clientToken: 'pubd0db83cc22017cb969f774ac7ede7ae3',
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'datadoghq.com',
  service: 'web-client',
  env: 'prod',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  allowedTracingUrls: ['https://api.arpio.io/'],
}

const dataDogConfigLogs: LogsInitConfiguration = {
  clientToken: 'pubd0db83cc22017cb969f774ac7ede7ae3', // Match with RUM client token
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  service: 'web-client',
  env: 'prod',
}

export const environment: EnvironmentInterface = {
  production: true,
  productName: 'Arpio',
  serverInAws: true,
  apiRoot: 'https://api.arpio.io',
  termsUrl: 'https://www.arpio.io/terms-of-service',
  registerSignupsInHubspot: true,
  mockIssues: false,
  fakeSync409: false,
  dataDogConfigRum: dataDogConfigRum,
  dataDogConfigLogs: dataDogConfigLogs,
}
